import React, { useEffect } from "react";
import { BrowserRouter, Switch, useLocation, useHistory } from "react-router-dom";

import BusinessHours from "../pages/BusinessHours/";
import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import AttendantsDashboard from "../pages/AttendantsDashboard/";
import TicketsDashboard from "../pages/TicketsDashboard/";
import RatingsDashboard from "../pages/RatingsDashboard";
import QueueOverridesDashboard from "../pages/QueueOverridesDashboard";
import GroupsDashboard from "../pages/GroupsDashboard";
import InternalChatsDashboard from "../pages/InternalChatsDashboard";
import Tickets from "../pages/Tickets/";
import Login from "../pages/Login/";
import LoginGroup from "../pages/LoginGroup/";
import Connections from "../pages/Connections/";
import Settings from "../pages/Settings/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import QuickAnswers from "../pages/QuickAnswers/";
import Queues from "../pages/Queues/";
import Categories from "../pages/Categories/";
import Subqueues from "../pages/Subqueues/";
import MyProfile from "../pages/MyProfile/";
import Flow from "../pages/Flow/";
import Labels from "../pages/Labels/";
import StarredMessages from "../pages/StarredMessages/";
import DispatchManager from "../pages/DispatchManager";
import DispatchContactsManager from "../pages/DispatchContactsManager";
import PasswordReset from "../pages/PasswordReset";
import PasswordResetValidation from "../pages/PasswordResetValidation";
import PasswordResetDefinition from "../pages/PasswordResetDefinition";
import ExpiredPasswordReset from "../pages/ExpiredPasswordReset";
import AutomaticMessages from "../pages/AutomaticMessages";
import InternalGroupsDashboard from "../pages/InternalGroupsDashboard";
import Management from "../pages/Management";
import PixMessages from "../pages/PixMessages";
import Page404 from "../pages/Page404/";
import BulkActions from "../pages/BulkActions";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import { AuthProvider } from "../context/Auth/AuthContext";
import { GlobalRegistersProvider } from "../context/GlobalRegisters/GlobalRegistersContext";
import { ThemeControllerProvider } from "../context/ThemeController";
import { GlobalThemeProvider } from "../context/GlobalTheme";
import { SocketAuthenticatedProvider, SocketLoginProvider, SocketProvider } from "../context/Socket/SocketContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { ModalImageCorsProvider } from "../context/ModalImageCors";
import ModalImageCors from "../components/ModalImageCors";

import DefaultValuesUtils from "../utils/classes/DefaultValuesUtils";

import Route from "./Route";

const RedirectToTickets = () => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (location.pathname === "/") history.replace(DefaultValuesUtils.ROUTES[100]);
  }, [location, history]);

  return null;
};

const Routes = () => {
  //  ************
  //  ** Return **
  //  ************
  console.log("- Application Init!");

  return (
    <BrowserRouter>
      <GlobalRegistersProvider>
        <RedirectToTickets />
        <SocketProvider>
          <SocketLoginProvider>
            <AuthProvider>
              <GlobalThemeProvider>
                <ThemeControllerProvider>
                  <Switch>
                    <Route exact path={DefaultValuesUtils.ROUTES[101]} component={Login} isRestricted />          
                    <Route exact path={DefaultValuesUtils.ROUTES[102]} component={LoginGroup} isRestricted />

                    <Route exact path={DefaultValuesUtils.ROUTES[103]} component={PasswordReset} isRestricted />
                    <Route exact path={DefaultValuesUtils.ROUTES[104]} component={PasswordResetValidation} isRestricted />
                    <Route exact path={DefaultValuesUtils.ROUTES[105]} component={PasswordResetDefinition} isRestricted />
                    <Route exact path={DefaultValuesUtils.ROUTES[106]} component={ExpiredPasswordReset} isRestricted />

                    <Route exact path={DefaultValuesUtils.ROUTES[999]} component={PrivacyPolicy} />
                    
                    <SocketAuthenticatedProvider>
                      <WhatsAppsProvider>
                        <LoggedInLayout>
                          <ModalImageCorsProvider>
                            <ModalImageCors />
                            <Route exact path="/" component={Tickets} isPrivate />
                            <Route exact path={DefaultValuesUtils.ROUTES[4]} component={Dashboard} isPrivate />
                            <Route exact path={DefaultValuesUtils.ROUTES[5]} component={AttendantsDashboard} isPrivate />  
                            <Route exact path={DefaultValuesUtils.ROUTES[6]} component={TicketsDashboard} isPrivate />              
                            <Route exact path={DefaultValuesUtils.ROUTES[7]} component={RatingsDashboard} isPrivate />
                            <Route exact path={DefaultValuesUtils.ROUTES[8]} component={QueueOverridesDashboard} isPrivate />
                            <Route exact path={DefaultValuesUtils.ROUTES[9]} component={GroupsDashboard} isPrivate />
                            <Route exact path={DefaultValuesUtils.ROUTES[10]} component={InternalChatsDashboard} isPrivate />
                            <Route exact path={DefaultValuesUtils.ROUTES[11]} component={InternalGroupsDashboard} isPrivate />
                            <Route exact path={`${DefaultValuesUtils.ROUTES[100]}/:ticketId?`} component={Tickets} isPrivate />
                            <Route exact path={DefaultValuesUtils.ROUTES[17]} component={Connections} isPrivate />
                            <Route exact path={DefaultValuesUtils.ROUTES[2]} component={Contacts} isPrivate />
                            <Route exact path={DefaultValuesUtils.ROUTES[3]} component={Labels} isPrivate />
                            <Route exact path={DefaultValuesUtils.ROUTES[16]} component={Users} isPrivate />
                            <Route exact path={DefaultValuesUtils.ROUTES[12]} component={PixMessages} isPrivate />
                            <Route exact path={DefaultValuesUtils.ROUTES[13]} component={AutomaticMessages} isPrivate />
                            <Route exact path={DefaultValuesUtils.ROUTES[14]} component={QuickAnswers} isPrivate />
                            <Route exact path={DefaultValuesUtils.ROUTES[15]} component={StarredMessages} isPrivate />
                            <Route exact path={DefaultValuesUtils.ROUTES[23]} component={MyProfile} isPrivate />
                            <Route exact path={DefaultValuesUtils.ROUTES[26]} component={Management} isPrivate />
                            <Route exact path={DefaultValuesUtils.ROUTES[27]} component={Settings} isPrivate />
                            <Route exact path={DefaultValuesUtils.ROUTES[28]} component={BulkActions} isPrivate />
                            <Route exact path={DefaultValuesUtils.ROUTES[19]} component={Queues} isPrivate />
                            <Route exact path={DefaultValuesUtils.ROUTES[20]} component={Categories} isPrivate />
                            <Route exact path={DefaultValuesUtils.ROUTES[21]} component={Subqueues} isPrivate />
                            <Route exact path={DefaultValuesUtils.ROUTES[22]} component={Flow} isPrivate />
                            <Route exact path={DefaultValuesUtils.ROUTES[18]} component={BusinessHours} isPrivate />
                            <Route exact path={DefaultValuesUtils.ROUTES[24]} component={DispatchManager} isPrivate />
                            <Route exact path={DefaultValuesUtils.ROUTES[25]} component={DispatchContactsManager} isPrivate />
                            <Route exact path={DefaultValuesUtils.ROUTES[998]} component={Page404} isPrivate />
                          </ModalImageCorsProvider>
                        </LoggedInLayout>
                      </WhatsAppsProvider>
                    </SocketAuthenticatedProvider>
                  </Switch>
                </ThemeControllerProvider>
              </GlobalThemeProvider>
            </AuthProvider>
          </SocketLoginProvider>
        </SocketProvider>
      </GlobalRegistersProvider>
    </BrowserRouter>
  );
};

export default Routes;
